module.exports = __webpack_public_path__ + "static/img/publicActive.bdb67f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/publicActive.png
// module id = ZI6n
// module chunks = 41